import type { ReactNode, Ref } from 'react';
import { forwardRef } from 'react';

import classNames from 'classnames';

import styles from './StyledOption.module.css';

import { Text } from '../../Text';
import { getMatchedWords } from './getMatchedWords';

export interface StyledOptionProps {
  /** Whether the option is hovered. Provided by downshift */
  hover?: boolean;
  /** Whether the option is selected. Provided by downshift */
  selected?: boolean;
  /** Whether to show the option with invalid state */
  invalid?: boolean;
  /** Whether to show the option with disabled state */
  disabled?: boolean;
  /** The value of the option. */
  value?: string | number;
  /** An optional substring used to highlight matched words and letters */
  match?: string;
  /** An optional boolean used to highlight all words and letters */
  bold?: boolean;
  /** The display content of the option */
  children: ReactNode;
  /** Optional class name */
  className?: string;
  /** The label to show for a selected option in the StyledSelect BorderLabel */
  label?: string | ReactNode;
}

export const StyledOption = forwardRef(StyledOption_);

function StyledOption_(props: StyledOptionProps, ref?: Ref<HTMLLIElement>) {
  const {
    className,
    hover,
    bold,
    invalid = false,
    disabled = false,
    selected,
    children,
    match,
    ...liProps
  } = props;
  return (
    <Text asChild color="Kale3" bold={bold}>
      <li
        ref={ref}
        className={classNames(styles.option, className, {
          [styles.hover]: hover,
          [styles.invalid]: invalid,
          [styles.disabled]: disabled,
          [styles.selected]: selected,
        })}
        {...liProps}
      >
        {getMatchedWords(match, children)}
      </li>
    </Text>
  );
}
